module.exports = __webpack_public_path__ + "img/calendar.e96fdde0.svg";